let currentCall = null;
let remoteAudioElements = [];

function cleanupRemoteAudio() {
  remoteAudioElements.forEach((element) => {
    element.remove();
  });
  remoteAudioElements = [];
}

export async function startLiveKitAudioCall({ url, token }) {
  const { Room, RoomEvent, createLocalAudioTrack, Track } = await import("livekit-client");

  await stopLiveKitAudioCall();
  cleanupRemoteAudio();

  const room = new Room({
    adaptiveStream: true,
    dynacast: true,
  });

  room.on(RoomEvent.TrackSubscribed, (track) => {
    if (track.kind !== Track.Kind.Audio) return;
    const element = track.attach();
    element.autoplay = true;
    element.dataset.livekitRemoteAudio = "true";
    document.body.appendChild(element);
    remoteAudioElements.push(element);
  });

  room.on(RoomEvent.TrackUnsubscribed, (track) => {
    track.detach().forEach((element) => element.remove());
  });

  await room.connect(url, token);
  const localAudioTrack = await createLocalAudioTrack({
    echoCancellation: true,
    noiseSuppression: true,
    autoGainControl: true,
  });
  await room.localParticipant.publishTrack(localAudioTrack);

  currentCall = { room, localAudioTrack };
  return currentCall;
}

export async function stopLiveKitAudioCall() {
  if (!currentCall) return;
  try {
    currentCall.localAudioTrack?.stop();
    currentCall.room?.disconnect();
  } finally {
    currentCall = null;
    cleanupRemoteAudio();
  }
}
